module.exports = __webpack_public_path__ + "assets/img/gio.82615d6a.jpg";